// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ClerkProvider } from '@clerk/clerk-react'
// Import your Publishable Key
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error('Add your Clerk Publishable Key to the .env file')
}

ReactDOM.render(
  <React.StrictMode>
      <ClerkProvider 
        publishableKey={PUBLISHABLE_KEY}
        signInForceRedirectUrl={process.env.REACT_APP_CLERK_SIGN_IN_FORCE_REDIRECT_URL}
        signUpForceRedirectUrl={process.env.REACT_APP_CLERK_SIGN_UP_FORCE_REDIRECT_URL}
        signInFallbackRedirectUrl={process.env.REACT_APP_CLERK_SIGN_IN_FALLBACK_REDIRECT_URL}
        signUpFallbackRedirectUrl={process.env.REACT_APP_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL}
      >
    <App />
    </ClerkProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
